import { Image, theme } from 'antd';
import logo from '/atravel.png';
import { HtmlHTMLAttributes, ImgHTMLAttributes } from 'react';
import { env } from '../../../services/utils';

export default function Logo(props: HtmlHTMLAttributes<Element> & {
    alt?: ImgHTMLAttributes<HTMLImageElement>['alt'],
}) {
    const {
        token: { colorPrimary },
    } = theme.useToken();
    
    return env.DEV
        ? (<>
            <svg {...props} role="img" viewBox="0 0 214 46" width="214" height="46" aria-label={ props.alt }>
                <image href={logo} width="214" height="46" x="0" y="0" opacity={0.5} style={{
                    filter: 'grayscale(1)'
                }} />
                <text x="180" y="43" fill={colorPrimary} font-family="sans-serif" font-weight="bold" font-size="1rem" stroke={colorPrimary} stroke-width="0.7">DEV</text>
            </svg>
        </>)
        : (<>
            <Image
                alt="Logo"
                {...props}
                src={logo}
                preview={false}
            />
        </>);
}
